module.exports = __webpack_public_path__ + "static/media/gto-logo.babc7513.png";